export default __webpack_public_path__ + "static/media/031-jogger pants.5a7e6c4f.svg";